import { Factory, Layers, MapPin, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  { icon: Factory, t: "Preço direto da fábrica", d: "Condições competitivas para sua obra ou empresa." },
  { icon: Layers, t: "Qualidade", d: "Produtos selecionados para diferentes necessidades." },
  { icon: MapPin, t: "Manaus", d: "Atendimento local e personalizado." },
  { icon: MessageCircle, t: "Atendimento rápido", d: "Consulte preços e disponibilidade diretamente pelo WhatsApp." },
];

export const Differentials = () => (
  <section id="diferenciais" className="relative overflow-hidden bg-[#0c0a09] py-24 sm:py-32" data-testid="differentials-section">
    <div className="pointer-events-none absolute -right-10 top-10 font-display text-[22vw] font-black uppercase leading-none text-white/[0.03] select-none">Destak</div>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Diferenciais</Eyebrow>
        <h2 className="font-display mt-5 max-w-3xl text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">
          Por que escolher a <span className="text-[#FACC15]">Destak?</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map(({ icon: Icon, t, d }, i) => (
          <Reveal key={t} delay={i * 0.1} className="h-full bg-[#0c0a09]">
            <div className="group relative flex h-full flex-col p-8 transition-colors duration-500 hover:bg-[#FACC15]" data-testid={`differential-${i + 1}`}>
              <div className="flex items-start justify-between">
                <span className="grid h-14 w-14 place-items-center rounded-full bg-[#FACC15] text-[#0c0a09] transition-[background-color,color,transform] duration-500 group-hover:rotate-12 group-hover:bg-[#0c0a09] group-hover:text-[#FACC15]">
                  <Icon className="h-6 w-6" />
                </span>
                <span className="font-mono-x text-xs text-stone-400 group-hover:text-[#0c0a09]">0{i + 1}</span>
              </div>
              <h3 className="font-display mt-10 text-3xl font-black uppercase leading-none text-white transition-colors duration-500 group-hover:text-[#0c0a09]">{t}</h3>
              <p className="mt-4 text-sm leading-relaxed text-stone-300 transition-colors duration-500 group-hover:text-[#0c0a09]">{d}</p>
              <span className="absolute bottom-0 left-0 h-1 w-0 bg-[#FACC15] transition-[width] duration-500 group-hover:w-full group-hover:bg-[#0c0a09]" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
